import React from 'react';
import {
  Card,
  InputNumber,
  Form,
  Input,
  Spin,
  Row,
  Col,
  Switch,
  Button,
  Select,
  Icon,
  Tag,
  Tooltip,
  Modal,
} from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'dva';
import { Prompt } from 'dva/router';
import { CancelToken } from 'axios';
import {
  AttributesOptions,
  AttributeTypes,
  Campaigns,
  Operators,
  Conditions,
  Assertions,
} from '../LeadScoringAttributeTypeSelector/Attributes';
import { ButtonBar, RemoteSelectInput, SelectInput } from '../../../components';
import styles from './../styles.less';
import AttributeValueSelector from '../LeadScoringAttributeValueSelector';
import LeadScoringAttributeTypeSelector from '../LeadScoringAttributeTypeSelector';
import { ACTION_PAGEGROUPS_LOADLIST } from '../../../models/pageGroups';
import { ACTION_COUNTRY_REGIONS_LOAD_LIST } from '../../../models/countryRegions';
import { ACTION_CAMPAIGNS_LOAD_LIST } from '../../../models/campaigns';
import { searchClassificationCodes2ndLevelRequest } from '../../../services/branches';
import LeadScoringVisitsTest from '../LeadScoringVisitsTest';
import { leadScoringTestAttributes } from '../../../services/leadScoring';
import { helpers } from '../../../utils';
import { WithHubspotProjectPermissions } from '../../Permissions';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
const booleanAttributes = [AttributeTypes.email_click, AttributeTypes.phone_click, AttributeTypes.form_submit, AttributeTypes.isp, AttributeTypes.hidden];

class LeadScoringItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      testPeriodDays: 30,
      visitsLoading: false,
      visits: [],
      projectId: this.props.app.currentProjectId || this.props.match.params.projectId,
      copyProjectId: this.props.match.params.copyProjectId || null,
      showTestVisits: false,
      isSubmitted: false,
      hubspot_enabled: false,
      hubspot_task_owner_id: null,
      profile: {
        id: this.props.match.params.leadScoringId ?
          Number(this.props.match.params.leadScoringId).toString() :
          null,
        name: '',
        value: '',
        connector: 'and',
        enabled: false,
        hubspot_enabled: false,
        isPublic: false,
        scoring_attributes: [],
      },
      classificationCodes: [],
      branches: [],
      pageGroups: [],
      countryRegions: [],
      campaigns: [],
      pipelineDealStages: [],
    };
    this.isDataChanged = false;
  }

  componentDidMount() {
    const {
      projectId,
      copyProjectId,
      profile: {
        id: profileId,
      },
    } = this.state;

    this.props.dispatch({
      type: 'hubspot/loadPipelines',
      payload: {
        projectId,
      },
    });

    if (profileId || copyProjectId) {
      const payload = {
        projectId,
        id: profileId || copyProjectId,
      };

      this.props.dispatch({ type: 'leadScoring/loadItem', payload }).then(() => {
        const profile = this.props.leadScoring.profilesItem;
        const scoring_attributes = profile.scoring_attributes;
        profile.isPublic = !profile.private;
        if (copyProjectId) {
          profile.id = null;
        }
        scoring_attributes.forEach((attribute, i) => {
          attribute.values.forEach((item, n) => {
            if (item.value.gte || item.value.lte) {
              scoring_attributes[i].values[n].label = this.getRangeValueLabel(item.value);
            }
          });
        });

        profile.hubspot_task_owner_id = profile.hubspot_task_owner ? profile.hubspot_task_owner.id || null : null;

        this.setState({
          profile,
        });
        this.attrsOnLoad = this.getAttributeValues(_.cloneDeep(scoring_attributes));
      });
    } else {
      this.props.dispatch({
        type: 'projects/loadDetail', payload: { id: projectId },
      }).then((data) => {
        this.setState({
          profile: {
            ...this.state.profile,
            hubspot_pipeline_id: data.hubspot_pipeline_default_id,
            hubspot_pipeline_stage_id: data.hubspot_pipeline_default_stage_id,
          },
        });
      });
    }

    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: profileId ?
          'Component.LeadScoring.List.Profile.Edit' :
          'Component.LeadScoring.List.Profile.Create',
      },
    });

    this.props.dispatch({ type: 'countries/loadList' });

    this.populateLeadLabels();
    this.populateBranches();
    this.populatePageGroups();
    this.populateCountryRegions();
    this.populateCampaigns();
    this.populateHubspotOwners();
  }

  componentDidUpdate(prevProps, prevState) {
    const { profile } = this.state;
    const pipelines = this.props.hubspot.pipelines[this.state.projectId] || [];
    if (profile.hubspot_pipeline_id !== prevState.profile.hubspot_pipeline_id || (profile.hubspot_pipeline_id && !this.state.pipelineDealStages.length && pipelines.length)) {
      const pipeline = pipelines.find(p => p.id === profile.hubspot_pipeline_id);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ pipelineDealStages: pipeline ? pipeline.stages : [] });
    }
  }

  getAttributeValues = (attr) => {
    return attr.filter(item => item.values).map(item => _.pick(item, ['values']));
  };

  getAttributeByIndex(index) {
    return this.state.profile.scoring_attributes[index];
  }

  getAttributeDefaults = (type) => {
    const attributeOptions = AttributesOptions.find(i => i.type === type);
    const operator = attributeOptions.operators[0];

    return {
      type,
      operator,
      negative: false,
      condition: attributeOptions.conditions[0],
      value: (Operators.range || Operators.gte || Operators.lte) === operator ? { lte: null, gte: null } : null,
      values: [],
    };
  }

  getRangeValueLabel = (item) => {
    if (item.lte === Number.MAX_SAFE_INTEGER) {
      return `${this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.gte' })} ${item.gte}`;
    } else if (item.gte === 0) {
      return `${this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.lte' })} ${item.lte}`;
    }

    return `${item.gte} - ${item.lte}`;
  }

  filterAssigneeOption = (inputValue, option) => {
    return option.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
  }

  attributeTagValuesAreVisible = (index) => {
    const attribute = this.state.profile.scoring_attributes[index];

    if (!attribute) { // no attribute, nothing to show
      return false;
    }

    if (attribute.values.length === 0) { // no values, nothing to show
      return false;
    }

    return !booleanAttributes.includes(attribute.type);
  }

  populateBranches() {
    if (this.props.app.useCustomBranches) {
      this.props.dispatch({ type: 'branches/loadList',
        payload: {
          filter: {
            client_id: this.props.app.selectedClient.id,
          },
        } }).then((resp) => {
        this.setState({ branches: resp.data });
      });
    }
  }

  populateLeadLabels() {
    this.props.dispatch({
      type: 'leadLabels/loadList',
      payload: {
        filter: {
          client_id: this.props.app.selectedClient.id,
        },
      },
    });
  }

  populatePageGroups() {
    this.props.dispatch({
      type: ACTION_PAGEGROUPS_LOADLIST,
      payload: {
        projectId: this.state.projectId,
      },
    }).then((resp) => {
      this.setState({ pageGroups: resp.data });
    });
  }

  populateCountryRegions() {
    this.props.dispatch({
      type: ACTION_COUNTRY_REGIONS_LOAD_LIST,
      payload: {
        filter: {
          client_id: this.props.app.selectedClient.id,
        },
      },
    }).then((resp) => {
      this.setState({ countryRegions: resp.data });
    });
  }

  populateCampaigns() {
    this.props.dispatch({
      type: ACTION_CAMPAIGNS_LOAD_LIST,
      payload: {
        projectId: this.state.projectId },
    }).then((resp) => {
      this.setState({ campaigns: resp.data });
    });
  }

  populateHubspotOwners() {
    if (this.props.hubspotOwners.assigned[this.state.projectId]) {
      return;
    }

    this.props.dispatch({
      type: 'hubspotOwners/assigned',
      payload: {
        projectId: this.state.projectId,
      },
    });
  }

  cancelAction() {
    const projectId = this.state.projectId;

    if (this.props.modal) {
      this.props.onCancel();
    } else {
      this.props.dispatch({
        type: 'app/goToRoute',
        payload: { routeName: 'LEAD_SCORING_LIST', projectId },
      });
    }
  }

  addCondition() {
    const { profile } = this.state;

    profile.scoring_attributes.push(
      this.getAttributeDefaults(AttributeTypes.lead_label),
    );

    this.setState({ profile });
  }

  deleteCondition(index) {
    const { profile } = this.state;
    profile.scoring_attributes = profile.scoring_attributes.filter((item, i) => i !== index);
    this.setState({ profile });
  }

  mapAttributesToApi = (attributes) => {
    return attributes.map((i) => {
      return {
        ...i,
        values: booleanAttributes.includes(i.type) ? [true] : i.values.map(this.attributeValuesToStore),
      };
    });
  }

  /**
   * @param att the attributes to test, see `getAttributeByIndex`
   * @returns {Promise<void>}
   */
  testAttributes = async (att) => {
    this.setState({ showTestVisits: true, visitsLoading: true });
    const attributes = this.mapAttributesToApi(att);

    try {
      const response = await leadScoringTestAttributes(
        {
          includes: 'company.country',
          projectId: this.state.projectId,
          limit: 1000,
          orderColumn: 'first_action_timestamp',
          orderDirection: 'desc',
        },
        moment().subtract(this.state.testPeriodDays, 'day').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
        this.state.profile.connector,
        attributes,
      );

      const visits = response.data.map((visit) => {
        return {
          id: visit.id,
          country: visit.company.country,
          company: { id: visit.company.id, company_name: visit.company.company_name },
          first_action_timestamp: visit.first_action_timestamp,
          visit_duration: visit.visit_duration,
          page_views: visit.page_views,
        };
      });
      this.setState({
        showTestVisits: true,
        visitsLoading: false,
        visits,
      });
    } catch (e) {
      helpers.processException(e);
      this.setState({ showTestVisits: false });
    }
  }

  removeValue(e, index, i) {
    e.preventDefault();
    const attribute = this.getAttributeByIndex(index);
    attribute.values.splice(i, 1);
    this.updateAttributeState(index, attribute);
  }

  handleChange = (name, value) => {
    const { profile } = this.state;
    const newProfile = { ...profile, [name]: value };
    if (name === 'hubspot_pipeline_id') {
      newProfile.hubspot_pipeline_stage_id = null;
    }
    this.setState({ profile: newProfile });
  }

  /**
   * @param value the value from scoring_attributes
   * @returns {*} return value, ready to store
   */
  attributeValuesToStore = (value) => {
    return value.value.gte !== undefined ?
      { gte: value.value.gte, lte: value.value.lte } :
      String(value.value);
  }

  handleSubmit(e) {
    e.preventDefault();
    const {
      id,
      name,
      description,
      score,
      enabled,
      connector,
      isPublic,
      hubspot_enabled,
      hubspot_task_owner_id,
      hubspot_pipeline_id,
      hubspot_pipeline_stage_id,
    } = this.state.profile;

    let hasErrors = false;
    this.props.form.validateFieldsAndScroll((errors) => {
      hasErrors = !!errors;
    });
    if (hasErrors) {
      return;
    }

    this.setState({ isSubmitted: true });
    const attributes = this.mapAttributesToApi(this.state.profile.scoring_attributes);
    const data = {
      name,
      description,
      score,
      enabled,
      connector,
      private: !isPublic,
      scoring_attributes: attributes,
      hubspot_enabled,
      hubspot_task_owner_id,
      hubspot_pipeline_id,
      hubspot_pipeline_stage_id,
    };

    if (!data.hubspot_enabled) {
      data.hubspot_task_owner_id = null;
      data.hubspot_pipeline_id = null;
      data.hubspot_pipeline_stage_id = null;
    }

    this.props.dispatch({
      type: id ? 'leadScoring/update' : 'leadScoring/create',
      payload: {
        id,
        data,
        projectId: this.state.projectId,
        noredirect: this.props.modal,
      },
    }).then(
      response => response && response.success && this.props.modal && this.props.onSubmit(),
    );
  }

  updateAttributeState(index, attribute) {
    const { profile } = this.state;
    profile.scoring_attributes[index] = attribute;
    this.isDataChanged = !_.isEqual(this.attrsOnLoad, this.getAttributeValues(profile.scoring_attributes));
    this.setState({
      ...profile,
    });
  }

  classificationCodesLoader = (query) => {
    let cancel;
    const queryPart = { filter: { label: `*${query}*` } };
    const requestConfig = {
      cancelToken: new CancelToken((c) => {
        cancel = c;
      }),
    };

    const request = searchClassificationCodes2ndLevelRequest(queryPart, requestConfig);

    return {
      request,
      cancel,
    };
  }

  attributeTypeChange = (index, value) => {
    this.updateAttributeState(
      index,
      this.getAttributeDefaults(value.id),
    );
  }

  isAtLeastOneValueSet = (attributes) => {
    return this.mapAttributesToApi(attributes).filter(i => i.values.length > 0).length > 0;
  }

  renderVisits() {
    return (
      <Modal
        destroyOnClose
        footer={null}
        width="1020px"
        bodyStyle={{ padding: '40px 10px 10px 10px' }}
        visible={this.state.showTestVisits}
        onCancel={() => {
          this.setState({ showTestVisits: false });
        }}
      >
        <LeadScoringVisitsTest
          projectId={String(this.state.projectId)}
          displayTimezone={this.props.app.user.display_timezone}
          displayDateTimeFormat={this.props.app.user.display_datetime_format}
          loading={this.state.visitsLoading}
          visits={this.state.visits}
        />
      </Modal>
    );
  }

  renderValueField(index) {
    const attribute = this.getAttributeByIndex(index);
    const operator = attribute.operator;
    const type = attribute.type;

    const addValue = (idx, e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      const validate = () => {
        const mandatoryMessage = this.props.intl.formatMessage({ id: 'Common.Field.Required' });

        if ([Operators.range].includes(operator)) {
          attribute.error = {
            gte: attribute.value.value.gte == null ? mandatoryMessage : null,
            lte: attribute.value.value.lte == null ? mandatoryMessage : null,
          };

          return attribute.error.gte == null && attribute.error.lte == null;
        }

        return true;
      };

      if (!validate()) {
        this.updateAttributeState(idx, attribute);
        return;
      }

      if (attribute.value) {
        attribute.values.push(attribute.value);
        attribute.value = null;
        this.updateAttributeState(idx, attribute);
      }
    };

    const inputChange = (idx, e) => {
      e.preventDefault();
      const att = this.getAttributeByIndex(idx);

      att.value = {
        value: e.target.value,
        label: e.target.value,
      };

      this.updateAttributeState(idx, attribute);
    };

    const rangeChange = (idx, name, value, gteOrLte) => {
      const att = this.getAttributeByIndex(idx);
      att.value = attribute.value || {};
      // has to be object. value.gte / value.lte / value.label
      if (!att.value || !att.value.value) {
        att.value.value = {};
      }

      att.value.value[name] = value;
      att.value.label = this.getRangeValueLabel(att.value.value);

      // when gte or lte, handle the other one + label
      if (gteOrLte === true) {
        if (name === Operators.lte) {
          att.value.value.gte = 0;
          att.value.label = this.getRangeValueLabel(att.value.value);
        }

        if (name === Operators.gte) {
          att.value.value.lte = Number.MAX_SAFE_INTEGER;
          att.value.label = this.getRangeValueLabel(att.value.value);
        }
      }

      this.updateAttributeState(idx, att);
    };

    const selectChange = (idx, value) => {
      const att = this.getAttributeByIndex(idx);
      att.value = { value: value.id, label: value.label };
      this.updateAttributeState(idx, att);
      addValue(idx);
    };

    const selectedAttribute = this.getAttributeByIndex(index).values.map(i => String(i.value));
    let inputValueElement = (
      <div style={{ display: 'flex' }}>
        <Input
          maxLength={255}
          onPressEnter={e => e.preventDefault()}
          value={attribute.value ? attribute.value.value : null}
          name="value"
          onChange={e => inputChange(index, e)}
        />
        <button onClick={e => addValue(index, e)} className="card-btn">
          <Icon type="plus" />
        </button>
      </div>
    );

    if (operator === Operators.range) {
      inputValueElement = (
        <div style={{ display: 'flex' }}>
          <FormItem
            help={attribute.error ? attribute.error.gte : null}
            validateStatus={(attribute.error && attribute.error.gte) ? 'error' : null}
          >
            <InputNumber
              min={0}
              max={Number.MAX_SAFE_INTEGER}

              maxLength={255}
              value={(attribute.value && attribute.value.value) ? attribute.value.value.gte : null}
              name={Operators.gte}
              onChange={val => rangeChange(index, Operators.gte, val)}
              onPressEnter={e => e.preventDefault()}
            />
          </FormItem>
          <span className="el"> - </span>
          <FormItem
            help={attribute.error ? attribute.error.lte : null}
            validateStatus={(attribute.error && attribute.error.lte) ? 'error' : null}
          >
            <InputNumber
              min={0}
              max={Number.MAX_SAFE_INTEGER}
              maxLength={255}
              value={(attribute.value && attribute.value.value) ? attribute.value.value.lte : null}
              name={Operators.lte}
              onChange={val => rangeChange(index, Operators.lte, val)}
              onPressEnter={e => e.preventDefault()}
            />
          </FormItem>

          <button onClick={e => addValue(index, e)} className="card-btn">
            <Icon type="plus" />
          </button>
        </div>
      );
    }

    if (operator === Operators.gte) {
      inputValueElement = (
        <div style={{ display: 'flex' }}>
          <InputNumber
            min={0}
            max={Number.MAX_SAFE_INTEGER}
            maxLength={255}
            value={(attribute.value && attribute.value.value) ? attribute.value.value.gte : null}
            name="gte"
            onChange={val => rangeChange(index, Operators.gte, val, true)}
            onPressEnter={e => e.preventDefault()}
          />
          <button onClick={e => addValue(index, e)} className="card-btn">
            <Icon type="plus" />
          </button>
        </div>
      );
    }

    if (operator === Operators.lte) {
      inputValueElement = (
        <div style={{ display: 'flex' }}>
          <InputNumber
            min={0}
            max={Number.MAX_SAFE_INTEGER}
            maxLength={255}
            value={(attribute.value && attribute.value.value) ? attribute.value.value.lte : null}
            name="lte"
            onChange={val => rangeChange(index, Operators.lte, val, true)}
            onPressEnter={e => e.preventDefault()}
          />
          <button onClick={e => addValue(index, e, Operators.range)} className="card-btn">
            <Icon type="plus" />
          </button>
        </div>
      );
    }

    if (type === AttributeTypes.country) {
      inputValueElement = (
        <AttributeValueSelector
          options={this.props.countries.countriesList.map(c => ({ id: c.id, label: c.name }))}
          onChange={value => selectChange(index, value)}
          skipValues={selectedAttribute}
        />
      );
    }

    if (type === AttributeTypes.classification_code) {
      inputValueElement = (
        <RemoteSelectInput
          value={attribute.value ? { key: attribute.value.value, label: attribute.value.label } : undefined}
          nameKey="label"
          labelInValue
          style={{ width: '100%' }}
          remoteLoader={this.classificationCodesLoader}
          showArrow
          onBlur={() => this.setState({ classificationCodes: [] })}
          skipValues={selectedAttribute}
          onChange={(value) => {
            selectChange(index, { id: value.key, label: value.label });
          }}
        />
      );
    }

    if (type === AttributeTypes.branch) {
      inputValueElement = (
        <AttributeValueSelector
          options={this.state.branches.map(c => ({ id: c.id, label: c.name }))}
          onChange={value => selectChange(index, value)}
          skipValues={selectedAttribute}
        />
      );
    }

    if (type === AttributeTypes.lead_label) {
      inputValueElement = (
        <AttributeValueSelector
          options={this.props.leadLabels.leadLabelsList.map(c => ({ id: c.id, label: c.name }))}
          onChange={value => selectChange(index, value)}
          skipValues={selectedAttribute}
        />
      );
    }

    if (type === AttributeTypes.source) {
      inputValueElement = (
        <AttributeValueSelector
          options={Object.keys(Campaigns).map(c => ({
            id: c,
            label: this.props.intl.formatMessage({ id: `Visit.Source.ValueLabel.${c}` }),
          }))}
          onChange={value => selectChange(index, value)}
          skipValues={selectedAttribute}
        />
      );
    }

    if (type === AttributeTypes.page_group) {
      inputValueElement = (
        <AttributeValueSelector
          options={this.state.pageGroups.map(c => ({ id: c.id, label: c.name }))}
          onChange={value => selectChange(index, value)}
          skipValues={selectedAttribute}
        />
      );
    }

    if (type === AttributeTypes.country_group) {
      inputValueElement = (
        <AttributeValueSelector
          options={this.state.countryRegions.map(c => ({ id: c.id, label: c.name }))}
          onChange={value => selectChange(index, value)}
          skipValues={selectedAttribute}
        />
      );
    }

    if (type === AttributeTypes.campaign) {
      inputValueElement = (
        <AttributeValueSelector
          options={this.state.campaigns.map(c => ({ id: c.id, label: c.name }))}
          onChange={value => selectChange(index, value)}
          skipValues={selectedAttribute}
        />
      );
    }

    // its boolean fields and have no value
    if (booleanAttributes.includes(type)) {
      inputValueElement = null;
    }

    const getLabel = () => {
      return type === AttributeTypes.duration ?
        <FormattedMessage id="Component.LeadScoring.Form.Value.Duration" /> :
        <FormattedMessage id="Component.LeadScoring.Form.Value" />;
    };

    return (
      <FormItem
        style={{ width: '100%' }}
        label={inputValueElement ? getLabel() : null}
      >
        {inputValueElement}
      </FormItem>
    );
  }

  renderOperatorField(index) {
    const attribute = this.getAttributeByIndex(index);

    const attributeOptions = AttributesOptions.find(i => i.type === attribute.type);
    const availableOperators = attributeOptions ? attributeOptions.operators : [];

    const operators = [
      {
        id: Operators.eq,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.eq' }),
      },
      {
        id: Operators.contains,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.contains' }),
      },
      {
        id: Operators.starts_with,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.starts_with' }),
      },
      {
        id: Operators.ends_with,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.ends_with' }),
      },
      {
        id: Operators.gte,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.gte' }),
      },
      {
        id: Operators.lte,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.lte' }),
      },
      {
        id: Operators.range,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.range' }),
      },
      {
        id: Operators.regexp,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.regexp' }),
      },
    ];

    const visibleOperators = operators.filter((i) => {
      return availableOperators.indexOf(i.id) > -1;
    });

    const change = (value) => {
      attribute.operator = value;
      attribute.value = null;
      this.updateAttributeState(
        index,
        attribute,
      );
    };

    return (
      <Select
        onChange={change}
        name="operator"
        value={attribute.operator}
      >
        {visibleOperators.map((option, i) =>
          (<Option key={i} value={option.id}>
            {option.label}
          </Option>),
        )}
      </Select>
    );
  }

  renderConditionField(index) {
    const attribute = this.getAttributeByIndex(index);
    const attributeOptions = AttributesOptions.find(i => i.type === attribute.type);
    const availableConditions = attributeOptions ? attributeOptions.conditions : [];

    const conditions = [
      {
        id: Conditions.and,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.and' }),
      },
      {
        id: Conditions.or,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.or' }),
      },
    ];
    const visible = conditions.filter((i) => {
      return availableConditions.indexOf(i.id) > -1;
    });

    const change = (value) => {
      attribute.condition = value;
      this.updateAttributeState(index, attribute);
    };

    return (
      <Select
        onChange={change}
        name="condition"
        value={attribute.condition}
      >
        {visible.map((option, i) =>
          (<Option key={i} value={option.id}>
            {option.label}
          </Option>),
        )}
      </Select>
    );
  }

  renderAssertionField(index) {
    const attribute = this.getAttributeByIndex(index);
    const options = [
      {
        id: Assertions.is,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.Is' }),
      },
      {
        id: Assertions.not,
        label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.Not' }),
      },
    ];

    const change = (value) => {
      attribute.negative = value === Assertions.not;
      this.updateAttributeState(index, attribute);
    };

    return (
      <Select onChange={change} name="assertion" value={attribute.negative ? Assertions.not : Assertions.is}>
        {options.map((option, i) =>
          (<Option key={i} value={option.id}>
            {option.label}
          </Option>),
        )}
      </Select>
    );
  }

  render() {
    const assignees = this.props.hubspotOwners.assigned[this.state.projectId] || [];
    const { profile } = this.state;
    const { getFieldDecorator } = this.props.form;
    const pipelines = this.props.hubspot.pipelines[this.state.projectId] || [];

    return (
      <Spin
        spinning={
          !!this.props.loading.effects['leadScoring/create'] ||
          !!this.props.loading.effects['leadScoring/update'] ||
          !!this.props.loading.effects['leadScoring/loadItem'] ||
          !!this.props.loading.effects['hubspotOwners/assigned'] ||
          !!this.props.loading.effects['hubspot/loadPipelines'] ||
          !!this.props.loading.effects['projects/loadDetail']
        }
      >
        <Prompt
          when={!this.state.isSubmitted && (this.isDataChanged || this.props.form.isFieldsTouched())}
          message={this.props.intl.locale}
        />
        <div className={styles.containerLarge}>
          <Form
            onSubmit={this.handleSubmit.bind(this)}
            className={styles.scoringProfileForm}
          >
            <Card>
              <Row>
                <h2>
                  <FormattedMessage id="Component.LeadScoring.Title.Settings" />
                </h2>
              </Row>
              <Row type="flex" justify="space-between">
                <Col xl={11} lg={24} sm={24}>
                  <Row>
                    <Col span={19}>
                      <FormItem label={<FormattedMessage id="Component.LeadScoring.Grid.ProfileName" />}>
                        {getFieldDecorator('name', {
                          rules: [{
                            required: true,
                            message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
                          }],
                          initialValue: profile.name,
                        })(
                          <Input
                            type="text"
                            minLength={3}
                            maxLength={255}
                            onChange={e => this.handleChange('name', e.target.value)}
                          />,
                        )}
                      </FormItem>
                    </Col>
                    <Col span={4} offset={1}>
                      <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.ProfileScore" />}>
                        {getFieldDecorator('score', {
                          initialValue: profile.score,
                        })(
                          <InputNumber
                            maxLength={255}
                            min={0}
                            max={10}
                            style={{ fontFamily: 'normal' }}
                            onChange={e => this.handleChange('score', e)}
                          />,
                        )}
                      </FormItem>
                    </Col>
                  </ Row>
                  <Row>
                    <Col span={3}>
                      <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.Public" />}>
                        <Tooltip
                          placement="bottom"
                          title={profile.id ?
                            <FormattedMessage id="Component.LeadScoring.Form.PublicDisabledOnEditHint" /> : null}
                        >
                          <span>
                            {getFieldDecorator('isPublic')(
                              <Switch
                                checked={profile.isPublic}
                                disabled={!!profile.id}
                                onChange={e => this.handleChange('isPublic', e)}
                              />,
                            )}
                          </span>
                        </Tooltip>
                      </FormItem>
                    </Col>
                    <Col span={3}>
                      <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.Enabled" />}>
                        {getFieldDecorator('enabled')(
                          <Switch
                            checked={profile.enabled}
                            onChange={e => this.handleChange('enabled', e)}
                          />,
                        )}
                      </FormItem>
                    </Col>
                    <Col span={14} offset={4}>
                      <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.Connector" />}>
                        {getFieldDecorator('connector', {
                          rules: [{
                            required: true,
                          }],
                          initialValue: profile.connector,
                        })(
                          <Select onChange={e => this.handleChange('connector', e)}>
                            <Option value="and">
                              <FormattedMessage
                                id="Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.and"
                              />
                            </Option>
                            <Option value="or">
                              <FormattedMessage id="Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.or" />
                            </Option>
                          </Select>,
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                </Col>
                <Col xl={11} lg={24} sm={24}>
                  <Row>
                    <Col span={24}>
                      <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.ShortDescription" />}>
                        {getFieldDecorator('description', {
                          initialValue: profile.description,
                        })(
                          <TextArea
                            rows={6}
                            maxLength={1000}
                            onChange={e => this.handleChange('description', e.target.value)}
                          />,
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row type="flex" justify="center" align="bottom">
                    <Col span={14}>
                      <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.TestingPeriod" />}>
                        <Select
                          value={this.state.testPeriodDays}
                          onChange={value => this.setState({ testPeriodDays: value })}
                        >
                          {[30, 60, 90].map((d) => {
                            return (
                              <Option value={d} key={d}>
                                {this.props.intl.formatMessage({ id: 'Component.LeadScoring.Form.TestPeriod' }, { days: d })}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span={10} className="text-right">
                      <Tooltip
                        title={<FormattedMessage id="Component.LeadScoring.Form.TestProfile.Hint" />}
                      >
                        <Button
                          size="large"
                          type="primary"
                          disabled={this.isAtLeastOneValueSet(this.state.profile.scoring_attributes) === false}
                          onClick={() => {
                            this.testAttributes(this.state.profile.scoring_attributes);
                          }}
                          style={{ marginBottom: '25px' }}
                        >
                          <FormattedMessage id="Component.LeadScoring.Form.TestProfile" />
                        </Button>
                      </Tooltip>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
            <WithHubspotProjectPermissions>
              <Card>
                <Row>
                  <h2>
                    <FormattedMessage id="Component.LeadScoring.Title.Hubspot" />
                  </h2>
                  <FormattedMessage id="Component.LeadScoring.Title.HubspotDescription" />
                </Row>
                <Row gutter={32}>
                  <Col span={3}>
                    <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.HubspotActive" />}>
                      <span>
                        {getFieldDecorator('hubspot_enabled', {
                          initialValue: profile.hubspot_enabled,
                        })(
                          <Switch
                            checked={profile.hubspot_enabled}
                            onChange={e => this.handleChange('hubspot_enabled', e)}
                          />,
                        )}
                      </span>
                    </FormItem>
                  </Col>
                  <Col span={7}>
                    <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.HubspotTaskAssignee" />}>
                      {getFieldDecorator('hubspot_task_owner_id', {
                        rules: [{
                          required: profile.hubspot_enabled,
                          message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
                        }],
                        initialValue: profile.hubspot_task_owner_id || null,
                      })(
                        <Select
                          disabled={!profile.hubspot_enabled}
                          showSearch
                          showArrow
                          onChange={e => this.handleChange('hubspot_task_owner_id', e)}
                          filterOption={this.filterAssigneeOption}
                        >
                          {assignees.map((c) => {
                            return (
                              <Select.Option
                                key={c.id}
                                value={c.id}
                                title={`${c.first_name} ${c.last_name}`}
                              >
                                {c.first_name} {c.last_name}
                              </Select.Option>
                            );
                          })}
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      label={<FormattedMessage id="Component.LeadScoring.Form.DealPipeline" />}
                    >
                      {getFieldDecorator('hubspot_pipeline_id', {
                        rules: [{
                          required: profile.hubspot_enabled,
                          message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
                        }],
                        initialValue: profile.hubspot_pipeline_id || null,
                      })(
                        <SelectInput
                          disabled={!profile.hubspot_enabled}
                          showArrow
                          options={pipelines}
                          onChange={(v) => {
                            this.props.form.setFieldsValue({
                              hubspot_pipeline_stage_id: null,
                            });
                            this.handleChange('hubspot_pipeline_id', v);
                          }}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      label={<FormattedMessage
                        id="Component.LeadScoring.Form.DealPipelineStage"
                      />}
                    >
                      {getFieldDecorator('hubspot_pipeline_stage_id', {
                        rules: [{
                          required: profile.hubspot_enabled,
                          message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
                        }],
                        initialValue: profile.hubspot_pipeline_stage_id || null,
                      })(
                        <SelectInput
                          disabled={!profile.hubspot_enabled || !this.state.pipelineDealStages.length}
                          showArrow
                          options={this.state.pipelineDealStages}
                          onChange={(v) => {
                            this.handleChange('hubspot_pipeline_stage_id', v);
                          }}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </WithHubspotProjectPermissions>

            {profile.scoring_attributes && profile.scoring_attributes.map((item, index) => (
              <Card
                key={index}
                className="custom-card"
                title={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Form.Attribute' }, { set: index + 1 })}
                extra={
                  <div className="action">
                    <Tooltip title={<FormattedMessage id="Component.LeadScoring.Form.TestAttribute.Hint" />}>
                      <Button
                        style={{ display: this.isAtLeastOneValueSet([this.getAttributeByIndex(index)]) ? 'block' : 'none' }}
                        icon="eye"
                        onClick={(e) => {
                          e.preventDefault();
                          this.testAttributes([this.getAttributeByIndex(index)]);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title={<FormattedMessage id="Component.LeadScoring.Form.DeleteAttribute.Hint" />}>
                      <Button
                        icon="close"
                        onClick={(e) => {
                          e.preventDefault();
                          this.deleteCondition(index);
                        }}
                      />
                    </Tooltip>
                  </div>
                }
              >
                <Row gutter={6}>
                  <Col xl={6} lg={12} sm={24}>
                    <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.Type" />}>
                      <LeadScoringAttributeTypeSelector
                        value={profile.scoring_attributes[index].type}
                        name="type"
                        onChange={value => this.attributeTypeChange(index, value)}
                      />
                    </FormItem>
                  </Col>
                  <Col xl={4} lg={12} sm={24}>
                    <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.Assertion" />}>
                      {this.renderAssertionField(index)}
                    </FormItem>
                  </Col>
                  <Col xl={4} lg={12} sm={24}>

                    <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.LogicalOperator" />}>
                      {this.renderOperatorField(index)}
                    </FormItem>

                  </Col>
                  <Col xl={4} lg={12} sm={24}>
                    <FormItem label={<FormattedMessage id="Component.LeadScoring.Form.Condition" />}>
                      {this.renderConditionField(index)}
                    </FormItem>
                  </Col>
                  <Col xl={6} lg={12} sm={24}>
                    <Row type="flex" align="bottom" style={{ width: '100%' }}>
                      {this.renderValueField(index)}
                    </Row>
                  </Col>
                </Row>
                <Row>
                  {this.attributeTagValuesAreVisible(index) && this.getAttributeByIndex(index).values.map((i, indx) =>
                    (<Tag
                      key={`${i}${indx}`}
                      closable
                      onClose={(e) => {
                        this.removeValue(e, index, indx);
                      }}
                    >
                      {i.label}
                    </Tag>),
                  )}
                </Row>
              </Card>
            ))}
            <Row type="flex" justify="end">
              <Button
                size="large"
                type="primary"
                onClick={this.addCondition.bind(this)}
                style={{ marginBottom: '25px' }}
              >
                <FormattedMessage id="Component.LeadScoring.Form.AddCondition" />
              </Button>
            </Row>
            <ButtonBar
              cancelAction={this.cancelAction.bind(this)}
              modal={this.props.modal}
            />
          </Form>
        </div>
        {this.renderVisits()}
      </Spin>
    );
  }
}

export default connect(
  ({ loading, leadLabels, leadScoring, countries, hubspot, campaigns, hubspotOwners, app }) =>
    ({
      loading,
      leadLabels,
      leadScoring,
      countries,
      hubspot,
      campaigns,
      hubspotOwners,
      app,
    }))(Form.create()(injectIntl(LeadScoringItem)),
);



// WEBPACK FOOTER //
// ./src/components/LeadScoring/LeadScoringItem/LeadScoringItem.js